import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';

import ListHeader from '../components/list/ListHeader';
import TableUI from '../components/list/TableUI';
import FilterPannel from '../components/filter/FilterPannel';
import withRouter from '../util/WithRouter';
import Const from '../util/Constants';
import SalesOrderAPI from '../api/SalesOrderAPI';
import Util from '../util/Util';
import HeaderViewList from '../components/list/HeaderViewList';
import ViewController from '../controller/ViewController';
import KeyValueAPI from '../api/KeyValueAPI';


class InstallmentList extends React.Component {
  constructor(props) {
    super(props);

    const query = new URLSearchParams(props.location.search);
    const filters = query.get("filters")
      ? JSON.parse(query.get("filters"))
      : null;

    this.models = reactLocalStorage.getObject(Const.Model);
    this.model = this.models.installment;

    const cView = reactLocalStorage.getObject(Const.CurrentViews);
    this.views = ViewController.getViews(Const.Installment);
    this.view = this.views.find(
      (view) => view.id === (filters ? 0 : cView.installment ? cView.installment : 0)
    );

    if (!this.view) {
      this.view = this.views.find((view) => view.type === 0);
    }

    this.lists = reactLocalStorage.getObject(Const.ListInstallment);
    if (!(this.lists instanceof Array)) {
      if (this.lists && Object.keys(this.lists).length !== 0) {
        const lists = [];
        lists.push({ ...this.lists, view: 0 });
        this.lists = lists;
      } else {
        this.lists = [];
      }
    }
    this.setList(filters);
    this.data = { installments: [], count: 0 };
    this.state = {
      inApiCall: true,
      isFilterOpen: this.list.isFilterOpen,

    };

    this.List = Util.isAllow(this.model.permission, Const.PermView);
    this.Update = Util.isAllow(this.model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(this.model.permission, Const.PermDelete);
    this.Restrict = Util.isAllow(this.model.permission, Const.PermRestricAcc);
  }

  componentDidMount() {
    // this.trackPageView();
    if (this.List) this.loadInstallments();
  }


  // componentDidUpdate(prevProps) {
  //   // If the path has changed, track the page view again
  //   if (this.props.location.pathname !== prevProps.location.pathname) {
  //     this.trackPageView();
  //   }
  // }
  // Track page view using Firebase Analytics
  // trackPageView() {
  //   const { location } = this.props;
  //   logEvent(analytics, 'page_view', {
  //     page_location: window.location.href,  
  //     page_path: location.pathname,           
  //     page_title: 'Installment Page',      
  //   });
  // }
  setList = (filters) => {
    let modelfields = reactLocalStorage.getObject(Const.FieldList);
    let lists = modelfields.installment;
    if (!lists) {
      lists = [];
      modelfields = { ...modelfields, installment: lists };
    }

    const fields = ['model', 'installment_date', 'amount', 'mode', 'account', 'installment_status', 'comment'];
    this.list = lists.find((list) => list.view === this.view.id);

    if (!this.list) {
      this.list = { view: this.view.id };
      modelfields = { ...modelfields, installment: [...modelfields.installment, this.list] };
    }
    const ViewFields = this.view && this.view.fields ? this.view.fields : [];
    this.list.fields = ViewFields.length > 3 ? ViewFields : (this.list.fields ? this.list.fields : fields);
    // this.list.fields = this.list.fields ? this.list.fields : fields;
    this.list.filters = filters
      ? filters
      : this.list.filters
        ? this.list.filters
        : [];
    this.list.pagination = this.list.pagination ? this.list.pagination : {};
    this.list.pagination.currentPage = this.list.pagination.currentPage
      ? this.list.pagination.currentPage
      : 1;
    this.list.pagination.pageCount = this.list.pagination.pageCount
      ? this.list.pagination.currentPage
      : 1;
    this.list.pagination.perPage = this.list.pagination.perPage
      ? this.list.pagination.perPage : 10;
    this.list.sorting = this.list.sorting ? this.list.sorting : { field: "id", order: -1 };

    if (this.ListRestrict) {
      this.list.fields =
        this.view && this.view.fields && this.view.fields.length > 0
          ? this.view.fields
          : fields;
    }

    this.list.fields = this.list.fields.filter((field) => {
      if (!field) {
        return false;
      }

      if (field.includes(Const.Opt))
        return (
          this.model.fields[field.split(Const.Opt)[0]] &&
          this.model.fields[field.split(Const.Opt)[0]].visible === Const.True
        );
      else
        return (
          this.model.fields[field] &&
          this.model.fields[field].visible === Const.True
        );
    });

    reactLocalStorage.setObject(Const.FieldList, modelfields);
  };


  saveListFilters = (filters) => {
    const tmpField = reactLocalStorage.getObject(Const.FieldList);
    const tmp = tmpField.installment.find((item) => item.view === this.view.id);
    tmp.filters = filters;
    reactLocalStorage.setObject(Const.FieldList, tmpField);
  };

  saveListFields = (fields) => {
    const tmpField = reactLocalStorage.getObject(Const.FieldList);
    const tmp = tmpField.installment.find((item) => item.view === this.view.id);
    tmp.fields = fields;
    reactLocalStorage.setObject(Const.FieldList, tmpField);
    let key = reactLocalStorage.getObject(Const.LoggedInUser).user_id;
    key = `${Const.FieldList}-${key}`;
    KeyValueAPI.save(key, KeyValueAPI.JSON, tmpField, () => { });
  };

  saveListSort = (sorting) => {
    const tmpField = reactLocalStorage.getObject(Const.FieldList);
    const tmp = tmpField.installment.find((item) => item.view === this.view.id);
    tmp.sorting = sorting;
    reactLocalStorage.setObject(Const.FieldList, tmpField);
    let key = reactLocalStorage.getObject(Const.LoggedInUser).user_id;
    key = `${Const.FieldList}-${key}`;
    KeyValueAPI.save(key, KeyValueAPI.JSON, tmpField, () => { });
  };

  savePerPage = (perPage) => {
    const tmpField = reactLocalStorage.getObject(Const.FieldList);
    const tmp = tmpField.installment.find((item) => item.view === this.view.id);
    tmp.pagination.perPage = perPage;
    reactLocalStorage.setObject(Const.FieldList, tmpField);
    let key = reactLocalStorage.getObject(Const.LoggedInUser).user_id;
    key = `${Const.FieldList}-${key}`;
    KeyValueAPI.save(key, KeyValueAPI.JSON, tmpField, () => { });
  };

  savePageChange = (currentPage) => {
    const tmpField = reactLocalStorage.getObject(Const.FieldList);
    const tmp = tmpField.installment.find((item) => item.view === this.view.id);
    tmp.pagination.currentPage = currentPage;
    reactLocalStorage.setObject(Const.FieldList, tmpField);
  };

  loadInstallments = () => {
    reactLocalStorage.setObject(Const.ListInstallment, this.lists);
    if (this.Restrict) {
      const user = reactLocalStorage.getObject(Const.LoggedInUser);
      const users = user.child;
      users.push(user.user_id);

    }
    const filters = ViewController.filters([...this.list.filters], this.view.filters, this.Restrict);
    this.setState({ ...this.state, inApiCall: true });
    SalesOrderAPI.getInstallmentList({ ...this.list, filters }, this.onReceived, this.onFail);
  };

  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };

  onReceived = (res) => {
    this.data.installments = res.data;
    this.data.count = res.count;
    this.list.pagination.pageCount = Math.ceil(
      res.count / this.list.pagination.perPage
    );
    this.setState({ ...this.state, popup: false, inApiCall: false });
  };

  onPageChange = (currentPage) => {
    this.list.pagination.currentPage = currentPage;
    this.loadInstallments();
  };

  onPerPageChange = (perPage) => {
    this.list.pagination.perPage = perPage;
    this.loadInstallments();
  };

  onFieldSelection = (fields) => {
    this.list.fields = fields;
    this.saveListFields(fields);
    this.loadInstallments();
  };

  toggleFilter = () => {
    this.list.isFilterOpen = !this.state.isFilterOpen;
    reactLocalStorage.setObject(Const.ListInstallment, this.list);
    this.setState({ ...this.state, isFilterOpen: !this.state.isFilterOpen });
  };

  onFilterChange = (filters) => {
    this.list.filters = filters;
    this.loadInstallments();
  };

  onAddEdit = index => {
    const i = index !== -1 ? this.data.installments[index].id : 0;
    this.props.navigate(`${this.props.match.path}/add-edit/${i}`);
  };
  onPreview = (index) => {
    this.props.navigate(`/sales-order/preview/${this.data.installments[index].sales_order_id}`);
  };

  onDelete = (index) =>
    Util.confirmAlert(
      "Delete",
      "Are you sure you want to delete",
      "Delete",
      "No",
      () => {
        this.setState({ ...this.state, inApiCall: true });
        SalesOrderAPI.delete(
          this.data.installments[index].id,
          this.onDeleteSuccess,
          this.onFail
        );
      }
    );

  onDeleteSuccess = () => {
    Util.showNotification("Successful", "Installment deleted successfully", "success");
    this.loadInstallments();
  };

  hidePopUp = () => this.setState({ ...this.state, popup: false });
  import = () => this.props.navigate(`/setting/import/add/${Const.Lead}`);
  export = (fields) =>
    Util.confirmAlert(
      "Export",
      `Are you sure you want to export to with applied filters ? `,
      "Export",
      "Cancel",
      () => {
        this.setState({ ...this.state, inApiCall: true });
        const filters = ViewController.filters(
          [...this.list.filters],
          this.view.filters,
          this.Restrict
        );
        SalesOrderAPI.exportModel(Const.Installment, filters, undefined, this.data.count, fields, this.model.model_no, this.onExport, this.onFail);
      }
    );

  onExport = () => {
    this.setState({ ...this.state, inApiCall: false });
    Util.showNotification(
      "Successful",
      "Installment Exported in progress. Please visit Settings",
      "success"
    );
  };
  //      onMassUpdate = (updates) => {
  //     const filters = ViewController.filters(
  //       [...this.list.filters],
  //       this.view.filters,
  //       this.Restrict
  //     );
  //     this.setState({ ...this.state, massUpdate: false, inApiCall: true });
  //     InstallmentAPI.massUpdate(
  //       filters,
  //       this.selected,
  //       updates,
  //       this.onMassUpdated,
  //       this.onFail
  //     );
  //   };

  //   showMassUpdate = () =>
  //     this.setState({ ...this.state, massUpdate: !this.state.massUpdate });
  //   showMassEmail = () =>
  //     this.setState({ ...this.state, massEmail: !this.state.massEmail });
  //   showMassSMS = () =>
  //     this.setState({ ...this.state, massSMS: !this.state.massSMS });
  //   showMassWhatsApp = () =>
  //     this.setState({ ...this.state, massWhatsApp: !this.state.massWhatsApp });


  //   onMassUpdated = () => {
  //     Util.showNotification(
  //       "Successful",
  //       "Lead Mass Updated successfull.",
  //       "success"
  //     );
  //     this.selected = [];
  //     this.loadLeads();
  //   };

  //   onMassEmail = (temp, config) => {
  //     this.setState({ ...this.state, massEmail: false, inApiCall: true });
  //     InstallmentAPI.massEmail(
  //       this.list,
  //       temp,
  //       config,
  //       this.onMassEmailSent,
  //       this.onFail
  //     );
  //   };
  //   onMassEmailSent = () => {
  //     Util.showNotification(
  //       "Successful",
  //       "Lead Mass Updated successfull.",
  //       "success"
  //     );
  //     this.loadLeads();
  //   };

  //   onMassSMS = (temp, config) => {
  //     this.setState({ ...this.state, massSMS: false, inApiCall: true });
  //     InstallmentAPI.massSMS(this.list, temp, config, this.onMassSmsSent, this.onFail);
  //   };
  //   onMassSmsSent = () => {
  //     Util.showNotification(
  //       "Successful",
  //       "Lead Mass Updated successfull.",
  //       "success"
  //     );
  //     this.selected = [];
  //     this.setState({ ...this.state, selected: !this.state.selected });
  //     this.loadLeads();
  //   };

  //   onMassWhatsApp = (temp, config) => {
  //     this.setState({ ...this.state, massSMS: false, inApiCall: true });
  //     const mainFilters = ViewController.getRestrictionsView(Const.Lead);
  //     const filters = ViewController.filters(
  //       [...this.list.filters],
  //       this.view.filters,
  //       mainFilters,
  //       this.Restrict
  //     );
  //     InstallmentAPI.massSMS(filters, temp, config, this.onMassSmsSent, this.onFail);
  //   };
  //   onMassWhatsAppSent = () => {
  //     Util.showNotification(
  //       "Successful",
  //       "Lead Mass Updated successfull.",
  //       "success"
  //     );
  //     this.selected = [];
  //     this.setState({ ...this.state, selected: !this.state.selected });
  //     this.loadLeads();
  //   };

  onSelect = (id) => {
    this.selected.push(id);
    this.setState({ ...this.state, selected: !this.state.selected });
  };
  onRemove = (id) => {
    this.selected = this.selected.filter((item) => id !== item);
    this.setState({ ...this.state, selected: !this.state.selected });
  };
  onSelectAll = () => {
    for (let i = 0; i < this.data.leads.length; i++) {
      const id = this.selected.find((item) => item === this.data.leads[i].id);
      if (!id) this.selected.push(this.data.leads[i].id);
    }
    this.setState({ ...this.state, selected: !this.state.selected });
  };
  onRemoveAll = () => {
    for (let i = 0; i < this.data.leads.length; i++) {
      this.selected = this.selected.filter(
        (item) => item !== this.data.leads[i].id
      );
    }
    this.setState({ ...this.state, selected: !this.state.selected });
  };

  onTabClick = (view) => {
    const cView = reactLocalStorage.getObject(Const.CurrentViews);
    cView.installment = view;
    reactLocalStorage.setObject(Const.CurrentViews, cView);
    if (this.view.id !== view) {
      this.view = this.views.find((item) => item.id === view);
      this.setList();
      this.loadInstallments();
    }
    this.setState({ ...this.state, isFilterOpen: false });
  };

  render() {
    return (
      <div>
        <HeaderViewList
          views={this.views}
          view={this.view}
          onTabClick={this.onTabClick}
        />
        <ListHeader
          model={this.model}
          name={this.model.label_name}
          pagination={this.list.pagination}
          listCount={this.data.count}
          filterCount={this.list.filters.length}
          onPageChange={this.onPageChange}
          perPage={this.list.pagination.perPage}
          onPerPageChange={this.onPerPageChange}
          toggleFilter={this.toggleFilter}
          onAddClick={() => this.onAddEdit(0)}
          add={false}
        />

        <div className="container-fluid ">
          <div className="row">
            <TableUI
              data={this.data.installments}
              model={this.model}
              fields={this.list.fields}
              pagination={this.list.pagination}
              inApiCall={this.state.inApiCall}
              onFieldChange={this.onFieldChange}
              onAddEdit={this.onAddEdit}
              onPreview={this.onPreview}
              // update={this.Update}
              // delete={this.Delete}
              onDelete={this.onDelete}
              onFieldSelection={this.onFieldSelection}
              isFilterOpen={this.state.isFilterOpen}
            />

            <FilterPannel
              filters={this.list.filters}
              fields={this.model.fields}
              onFilterChange={this.onFilterChange}
              isFilterOpen={this.state.isFilterOpen}
              restrict={this.Restrict}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(InstallmentList);
